import store from '../../store'
// import DeleteOrder from './../components/orderDelete.vue'
// import saleVerify from './../components/saleVerify.vue'
// import editDeliveriesTakedOrder from './../components/editDeliveriesTakedOrder.vue'
// import viewDelivertesOrder from './../components/viewPage.vue'
export default {
  className: 'Order', // 已收货订单
  title: '已收货订单',
  fields: [
    // {
    //   name: 'Number'
    // },
    {
      // 所属用户
      name: 'userid',
      note: '销售人员',
      validators: [
        val => (val) ? null : '所属用户不可为空'
      ]
    },
    {
      name: 'userCompany',
      note: '所属公司',
      validators: [
        val => (val) ? null : '所属公司不可为空'
      ]
    },
    {
      // 型号
      name: 'finishProductid',
      validators: [
        val => (val) ? null : '成品型号不可为空'
      ]
    },
    {
      // 吨数
      name: 'amount',
      validators: [
        val => (val) ? null : '吨数不可为空'
      ]
    },
    {
      // 麦头
      name: 'markid'
    },
    {
      // 包装
      name: 'packid'
    },
    {
      // 利润
      name: 'profit',
      validators: [
        val => (val) ? null : '利润不可为空'
      ]
    },
    {
      // 发出时间
      name: 'sentAt'
    },
    {
      // 状态
      name: 'status'
    },

    {
      // 备注
      name: 'remarks'
    },
    {
      // 订单客户
      name: 'clientid',
      validators: [
        val => (val) ? null : '客户不可为空'
      ]
    },
    {
      // 托盘
      name: 'palletid'
    },
    {
      // 交付日期
      name: 'shipDate'
    },
    {
      // 运费
      name: 'shipping',
      validators: [
        val => (val) ? null : '运费不可为空'
      ]
    },
    {
      // 成本
      name: 'costPrice',
      validators: [
        val => (val) ? null : '成本不可为空'
      ]
    },
    {
      // 下单日期
      name: 'orderDate'
    },
    {
      // 提成
      name: 'commission',
      validators: [
        val => (val) ? null : '提成不可为空'
      ]
    },
    // {
    //   // 其他费用
    //   name: 'anotherCost'
    // },
    {
      // 每吨运费
      name: 'pricePerTon'
    },
    {
      // 售价
      name: 'sellingPrice',
      validators: [
        val => (val) ? null : '售价不可为空'
      ]
    },

    {
      name: 'taxRate'
    },
    {
      // 客户提成
      name: 'clientCommission',
      validators: [
        val => (val) ? null : '客户提成不可为空'
      ]
    },
    {
      // 所属车间型号
      name: 'modelId',
      note: '车间型号'
    }
  ],
  // action: {
  //   create: false,
  //   verify: store.state.user && store.state.user.authority.deliveriesTakedOrder.verify
  //     ? {
  //       type: 'row',
  //       text: '审核',
  //       component: saleVerify
  //     } : false,
  //   view: store.state.user && store.state.user.authority.deliveriesTakedOrder.view ? {
  //     type: 'row',
  //     text: '查看',
  //     component: viewDelivertesOrder
  //   } : false,
  //   edit: store.state.user && store.state.user.authority.deliveriesTakedOrder.edit ? {
  //     type: 'row',
  //     text: '编辑',
  //     component: editDeliveriesTakedOrder
  //   } : false,
  //   delete: false,
  //   myDelete: store.state.user && store.state.user.authority.deliveriesTakedOrder.del
  //     ? {
  //       type: 'row',
  //       text: '删除',
  //       component: DeleteOrder
  //     }
  //     : false
  // },
  hooks: {
    beforeFetch ({ where }) {
      where.status = 'deliveriesTaked'
      if (store.state.user && store.state.user.allShopManagements === 'Yes') {

      } else {
        // where.shopManagementid = {
        //   $in: store.state.user.shopManagements
        // }
        where.finishProductid = {
          $inQuery: {
            where: {
              workShop: {
                $inQuery: {
                  where: {
                    objectId: { $in: store.state.user.shopManagements }
                  },
                  className: 'shopManagement'
                }
              }
            },
            className: 'finishProduct'
          }
        }
      }
      if (store.state.user && store.state.user.allClient === 'Yes') { } else {
        where.userid = store.state.user.objectId
      }
    }
  }
}
